import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';

import { ModalClosedPayload } from '@compeople-shared/design-system';
import { Observable } from 'rxjs';

@Component({
  selector: 'spa-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  /**
   * @deprecated Property title has side effects – use titleText instead
   */
  @Input() title = '';
  titleText = input<string>();

  // if modal to be closed by clicking outside its body
  @Input() dismissable = false;

  @Input() buttons: ModalComponentButtonConfig[] = [];

  @Input() width: 's' | 'm' | 'l' | 'xl' | 'xxl' = 'l';

  modalClosed(e: CustomEvent<ModalClosedPayload>) {
    if (!this.dismissable && e.detail.reason === 'background') {
      e.detail.preventCloseModal();
    }
  }
}

export interface ModalComponentButtonConfig {
  label: string;
  primary: boolean;
  action: (e: unknown) => void;
  disabled?: Observable<boolean>;
  dataTestID?: string;
}
